import 'source-map-support/register';

import path from 'path';

/**
 * Exports the path to the root of the project
 */
export default path.join(__dirname, '..', '..');
